module.exports = __webpack_public_path__ + "static/Two-c6a77a74a16425a1557a87d3285f2d8d.jpg";